import * as React from "react";
import {CSSProperties} from "react";
import {observer} from "mobx-react";
import {StoreBase} from "shared/utilities/Store/StoreBase";
import {StoreControl, StoreControlProps, StoreControlState} from "shared/controls/base/StoreControl";
import {ValidatorBase} from "shared/utilities/validator/ValidatorBase";
import {PropertyValidator} from "shared/utilities/validator/PropertyValidator";
import {Editor} from "slate-react";
import Plain from 'slate-plain-serializer'
import './Style.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBold} from "@fortawesome/free-solid-svg-icons/faBold";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faItalic} from "@fortawesome/free-solid-svg-icons/faItalic";
import {faUnderline} from "@fortawesome/free-solid-svg-icons/faUnderline";

import {Inline, Mark, Operation, Value} from "slate";
import {ColorButton} from "shared/controls/SingleInputs/SlateEditor/Buttons/ColorButton";
import {debug} from "util";
import {FontSizeButton} from "shared/controls/SingleInputs/SlateEditor/Buttons/FontSizeButton";
import {List} from "immutable";
import {HTMLSerializer} from "shared/controls/SingleInputs/SlateEditor/Serializers/HTMLSerializer";
import {ReactUtilities} from "shared/utilities/react/ReactUtilities";
import {SlateMarkBase} from "shared/controls/SingleInputs/SlateEditor/Marks/SlateMarkBase";
import {faAlignLeft} from "@fortawesome/free-solid-svg-icons/faAlignLeft";
import {faAlignRight} from "@fortawesome/free-solid-svg-icons/faAlignRight";
import {faAlignCenter} from "@fortawesome/free-solid-svg-icons/faAlignCenter";
import {faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {ServerItemFieldPicker} from "PageBuilder/pagebuilder/Controls/FieldPickerTextBox/ServerItemFieldPicker";
import {LicenseIsRequired} from "InternalShared/Dialog/LicenseIsRequired";

library.add(faBold);
library.add(faItalic);
library.add(faUnderline);
library.add(faAlignLeft);
library.add(faAlignRight);
library.add(faAlignCenter);

@observer
export class SlateEditor<S extends StoreBase=any> extends StoreControl<RNTextInputProps<S>, RNTextInputState> {
    static defaultProps: Partial<RNTextInputProps<any>> = {
        marks:[]
    };
    public editor:Editor;
    public Schemas:any;

    constructor(props: RNTextInputProps<S>) {
        super(props);

        this.state={
            IsValid:true,
            ErrorMessage:'',
            serializeValue:this.GetStringValue(),
            value:HTMLSerializer.Deserialize(this.GetStringValue(),this.props.marks) as any,
            displayColorPicker:false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<RNTextInputProps<S>>, nextContext: any): void {
        super.componentWillReceiveProps(nextProps, nextContext);
        if(this.state.serializeValue!=this.GetStringValue(nextProps.Store,nextProps.PropertyName))
        {
            this.setState({value:HTMLSerializer.Deserialize(this.GetStringValue(nextProps.Store,nextProps.PropertyName),this.props.marks) as any ,serializeValue:this.GetStringValue(nextProps.Store,nextProps.PropertyName)});
        }

    }


    public render() {
        this.Schemas={};
        this.Schemas.blocks={};

        this.Schemas.inlines={};
        this.Schemas.inlines.field={isVoid:true};


        let editor=this.props.marks.map(x=>x.GetMark(this)).filter(x=>x!=null);
        return (
            <div className={'rncontrol'} style={this.props.style}>
                <div>
                    {   this.props.Label!=''&&
                        <label style={{width: '100%', display: 'block'}}>{this.props.Label}</label>
                    }
                    <div className={'slateToolbar'} style={{display:'flex',alignItems:'center'}}>
                        {this.renderMarkButton('bold', <FontAwesomeIcon icon={'bold'}/>)}
                        {this.renderMarkButton('italic', <FontAwesomeIcon icon={'italic'}/>)}
                        {this.renderMarkButton('underlined', <FontAwesomeIcon icon={'underline'}/>)}
                        <ColorButton Color={this.GetCurrentColor()} ColorChanged={(e)=> this.ColorSelected(e)}/>
                        <FontSizeButton FontSize={this.GetCurrentSize()} SizeChanged={e=>this.SizeChanged(e)}/>
                        {
                            editor.map((x,index)=>
                                <React.Fragment key={index}>
                                    {x}
                                </React.Fragment>
                            )
                        }
                        {this.renderAlignButton('alignleft', <FontAwesomeIcon icon={'align-left'}/>)}
                        {this.renderAlignButton('aligncenter', <FontAwesomeIcon icon={'align-center'}/>)}
                        {this.renderAlignButton('alignright', <FontAwesomeIcon icon={'align-right'}/>)}
                        <div className={'slateButtonWrapper '}>
                            <button style={{width:25}} title={'Add Field'} onClick={(e)=>this.Add()}><FontAwesomeIcon icon={faPlus}/> </button>
                        </div>

                    </div>
                    <div className={'slateTextContainer'}>
                        <Editor schema={this.Schemas}  renderNode={(props,editor,next)=>this.RenderNode(props,editor,next)} style={{height:100,overflow:'auto'}}  ref={e=>this.editor=e} value={this.state.value}
                                onChange={e=>{this.Change(e)}}  renderMark={(props,editor,next)=>this.renderMark(props,editor,next)}/>
                    </div>
                    {this.GetValidationSection()}
                </div>
            </div>
        )
    }

    renderAlignButton (type, icon:any) {
        let isActive=false;
        let blocks=this.state.value.blocks;

       for(let i=0;i<this.state.value.blocks.size;i++)
       {
           let currentBlock=this.state.value.blocks.get(i);
           if(currentBlock.type=='paragraph')
           {
               if(currentBlock.data.get('className')==type)
                   isActive=true;
               else{
                   isActive=false;
                   break;
               }

           }

       }
        return (
            <div className={'slateButtonWrapper '+(isActive?"active":'')}  onMouseDown={event => this.onClickAlign(event, type)}>
                <button>
                    {icon}
                </button>
            </div>
        )
    }

    onClickAlign(event,type){
        let blocks=this.state.value.blocks;
        for(let i=0;i<blocks.size;i++)
        {
            let data:any=blocks.get(i).toJSON();
            data.data.className=type;
            this.editor.setNodeByKey(blocks.get(i).key,data);
        }



    }

    renderMarkButton (type, icon:any) {
        const isActive = this.hasMark(type);

        return (
            <div className={'slateButtonWrapper '+(isActive?"active":'')}  onMouseDown={event => this.onClickMark(event, type)}>
                <button>
                    {icon}
                </button>
            </div>
        )
    }

    onClickMark (event, type) {
        event.preventDefault();
        this.editor.toggleMark(type)
    }

    hasMark (type:any) {
        const { value } = this.state;
        return value.activeMarks.some(mark => mark.type === type)
    }


    GetValidators(): ValidatorBase[] {
        return [
            new PropertyValidator(this.props,"Required",()=>{return this.GetStringValue()!=''},"Required field")
        ];
    }

    renderMark (props, editor, next) {
        const { children, mark, attributes } = props

        switch (mark.type) {
            case 'bold':
                return <strong {...attributes}>{children}</strong>
            case 'code':
                return <code {...attributes}>{children}</code>
            case 'italic':
                return <em {...attributes}>{children}</em>
            case 'underlined':
                return <u {...attributes}>{children}</u>
            case 'color':
                return <span {...attributes} style={{color:mark.data.get('hex')}}>{children}</span>
            case 'size':
                return <span {...attributes} style={{fontSize:mark.data.get('size'),lineHeight:mark.data.get('size').toString().indexOf('px')>=0?mark.data.get('size'):mark.data.get('size') +'px'}}>{children}</span>
            default:
                for(let currentMark of this.props.marks)
                {
                    let node:any=currentMark.RenderMark(mark,children,attributes);
                    if(node!=null)
                        return node;
                }
                return next()
        }
    }

    private RenderNode(props: any, editor: any, next: () => any) {
        const { attributes, children, node } = props;

        if(props.node.type=='field') {

            let markList=props.node.nodes.get(0).getMarks().toArray();
            let label:any='Undefined';

            switch (props.node.data.get('SubType')) {
                case 'fixed':
                    label= 'Fixed field';
                    break;
                case 'field':
                    let value=props.node.data.get('FieldId');
                    let field=this.props.Fields.find(x=>x.Id==value);

                    if(field!=null)
                        label=field.Id+': '+(field.Label==null?'':field.Label);
                    break;

            }



            return <span {...attributes} style={{padding:'1px 2px',backgroundColor:'#679AFE',color:'white'}} >{label}</span>
        }

        if(props.node.type=='paragraph') {
            let styles:CSSProperties={};
            switch (props.node.data.get('className')) {
                case "aligncenter":
                    styles.textAlign='center';
                    break;
                case "alignleft":
                    styles.textAlign='left';
                    break;
                case "alignright":
                    styles.textAlign='right';
                    break;
            }

            return <p {...attributes} style={styles}>{children}</p>
        }
        switch (node.type) {
            default:
                return next()
        }
    }


    private ColorSelected(color: string) {
        this.state.value.marks.forEach(mark=>{
            if(mark.type=='color')
                this.editor.removeMark(mark);
        });
        this.editor.toggleMark(Mark.create({type:'color',data:{hex:color}}))
    }

    private GetCurrentColor() {
        let currentColor=this.state.value.activeMarks.find(x=>x.type=='color');
        if(currentColor!=null)
            return currentColor.data.get('hex');
        return '';
    }

    private GetCurrentSize() {
        let currentColor=this.state.value.activeMarks.find(x=>x.type=='size');
        if(currentColor!=null)
            return parseInt(currentColor.data.get('size').toString().replace('px',''));
        return 16;
    }

    private SizeChanged(e: number) {

        this.state.value.marks.forEach(mark=>{
            if(mark.type=='size')
                this.editor.removeMark(mark);
        });
        this.editor.toggleMark(Mark.create({type:'size',data:{size:e}}))
    }

    private Change(e: { operations: List<Operation>; value: Value }) {
        if(e.value.document!=this.state.value.document) {
            let serializedValue=HTMLSerializer.Serialize(e.value,this.props.marks);
            this.SetValue(serializedValue);
            this.setState({serializeValue:serializedValue});
        }
        this.setState({value:e.value});
    }

    private async Add() {

        if(rednaoVar.IsPr=='')
        {
            Dialog.Show(<LicenseIsRequired Message={"Fields in text is only available in the full version"}/>);
            return;
        }
        let fieldDialog=await Dialog.Show(<ServerItemFieldPicker Fields={this.props.Fields}/>);
        if(fieldDialog!=null)
        {
            let block=Inline.create(
                {
                    type:'field',
                    data:{
                        SupportMarks:true,
                        SubType:fieldDialog.Type,
                        FieldId:fieldDialog.Value,
                        IncludeLabel:true,
                    }
                }
            );
            let node=this.editor.insertInline(block);

        }
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface RNTextInputProps<S extends StoreBase> extends StoreControlProps<S>{
    style?:CSSProperties;
    Label:string;
    onChange?:(value:string)=>void;
    disabled?:boolean;
    type?:string;
    placeholder?:string;
    marks:SlateMarkBase[];
    Fields:any;
}

interface RNTextInputState extends StoreControlState{
    value:Value;
    displayColorPicker:boolean;
    serializeValue:string;
}

//#endregion "My Region"